/**
 * Count labels that read right for 1: "1 applicant", "2 applicants". Use for every "{n} {thing}" shown
 * to a person (2026-10-11: the Jobs table said "1 Applicants").
 */
export function pluralWord(n: number, singular: string, plural = `${singular}s`): string {
  return n === 1 ? singular : plural;
}

/** "1 applicant", "3 applicants" (the number, a space, then the word). */
export function countLabel(n: number, singular: string, plural = `${singular}s`): string {
  return `${n} ${pluralWord(n, singular, plural)}`;
}
